module.exports = __webpack_public_path__ + "media/brands/aprilia-734dbd68.png";